export const CHAVE_SESSAO = 'KEY_APP_BGG';

export function usuarioDaSessao() {
  try {
    const token=sessionStorage.getItem(CHAVE_SESSAO);
    if (!token) return null;
    const partes=token.split('.');
    if (partes.length!==3) return null;
    const texto=decodeURIComponent(Array.from(atob(partes[1]),c=>'%'+c.charCodeAt(0).toString(16).padStart(2,'0')).join(''));
    const dados=JSON.parse(texto);
    return Array.isArray(dados) && dados[0] && typeof dados[0]==='object' ? dados[0] : null;
  } catch (_) {return null;}
}

export function ehSuperadmin() {
  const u=usuarioDaSessao();
  return Boolean(u && Number(u.id)===1 && u.tipo==='A' && !u.suporte);
}

export function suporteDaSessao() {
  const u=usuarioDaSessao();
  return u && u.suporte && typeof u.suporte==='object' ? u.suporte : null;
}

export function somenteAuxFlex(usuario=usuarioDaSessao()) {
  return Boolean(usuario && usuario.tipo==='P' && String(usuario.origemprof||'').toUpperCase()==='FLEX' && Number(usuario.exibir_agenda)!==1);
}
